import config from '@wearetla/tla-essentials-tools/config';
import request from '@wearetla/tla-essentials-tools/utilities/request';
import { getDateLocale } from '/utilities/i18n';
import createI18nInstance from '/utilities/i18n/create-i18n-instance';
import { parse, format } from 'date-fns';

const getT = () => createI18nInstance().t;

// Functions
import processHtml from '../functions/process-html';

const eventServices = {
	getEvents: (filters = { page: 1 }) => {
		return new Promise((resolve, reject) => {
			const { term, ...rawFilters } = filters;
			request.get(
				`event/calendars`,
				{ ...(term ? { query: term } : {}), ...rawFilters },
				(payload, status, request) => {
					if (payload.events) {
						resolve({
							events: payload.events,
							pagination: request.data.pagination,
						});
					} else {
						reject(request);
					}
				}
			);
		});
	},
	old_getEvents: (filters = { page: 1 }) => {
		return new Promise((resolve, reject) => {
			const { term, ...rawFilters } = filters;
			request.get(
				`event/filter`,
				{ ...(term ? { query: term } : {}), ...rawFilters },
				(payload, status, request) => {
					if (payload.events) {
						resolve({
							events: payload.events,
							pagination: request.data.pagination,
						});
					} else {
						reject(request);
					}
				}
			);
		});
	},
	getEvent: (eventId) => {
		return new Promise((resolve, reject) => {
			request.get(`event/detail/${eventId}`, {}, (payload, status, request) => {
				if (payload?.event) {
					resolve({
						...payload.event,
						artist_detail: processHtml(payload.event.artist_detail),
					});
				} else {
					reject(request);
				}
			});
		});
	},
	getPrimaryEvent: () => {
		return new Promise((resolve) => {
			resolve(config.primaryEvent);
			// request.get(
			// 	'event/showcase',
			// 	{ showcase_type: 'MAIN_EVENT' },
			// 	(payload, status, request) => {
			// 		if (payload?.showcases?.length) {
			// 			resolve(payload.showcases[0].events?.find(event => event.highlight && event.calendar?.id) ?? payload.showcases[0].events.find(event => event.calendar?.id));
			// 		} else {
			// 			reject(request);
			// 		}
			// 	}
			// );
		});
	},
	getWorkshops: async () => {
		const t = getT();
		const locale = await getDateLocale();

		return new Promise((resolve, reject) => {
			request.get(`form/${config.primaryEvent?.workshops?.formId}`, false, (payload, status, request) => {
				if (status === 200 && payload?.form?.questions) {
					try {
						const dates = payload.form.questions.reduce((dates, question) => {
							try {
								const [category, label, rawEventDate, time] = question.title.split(' - ');
						
								const eventDateString = format(parse(rawEventDate, 'dd.MM.yyyy', new Date()), 'MMMM d', { locale });
		
								const matchingDate = dates.find(date => date.date === eventDateString) ?? {
									date: eventDateString,
									categories: []
								};
		
								const matchingCategory = matchingDate.categories.find(iterateCategory => iterateCategory.title === category) ?? {
									title: category,
									sessions: []
								};
		
								return [
									...dates.filter(date => date.date !== eventDateString),
									{
										...matchingDate,
										categories: [
											...(matchingDate.categories.filter(iterateCategory => iterateCategory.title !== matchingCategory.title)),
											{
												...matchingCategory,
												sessions: [
													...matchingCategory.sessions,
													{
														label: label,
														time: time,
														id: question.id,
														optionId: question.options[0].id,
														description: question.description,
														joinable: question.answer_limit > 0,
														isFull: !question.answerable,
														rsvp: question.options[0].answer,
													}
												].sort((a, b) => (a.time < b.time ? -1 : a.time > b.time ? 1 : 0))
											}
										].sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
									}
								].sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0))
							}
							catch(e) {
								console.error('Error parsing', question.title, e);

								return dates;
							}
						}, [])
	
						resolve({
							title: payload.form.title,
							subtitle: payload.form.description,
							dates
						});
					}
					catch(e) {
						console.error(e);
					}
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Workshoplar getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	attendWorkshop: (sessionId, optionId) => {
		const t = getT();
		return new Promise((resolve, reject) => {
			request.post(
				`form/${config.primaryEvent?.workshops?.formId}/answer`,
				{
					answers: [
						{
							question_id: sessionId,
							option_id: optionId,
						}
					]
				},
				(payload, status, request) => {
				if (status === 200) {
					resolve(
						request?.data?.meta?.messages?.success?.length
							? request?.data?.meta?.messages
							: { success: t('Katılımınız başarıyla sağlandı, teşekkür ederiz.') }
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Katılım güncellenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	resetWorkshopAttendance: (sessionId) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.delete(
				`form/${config.primaryEvent?.workshops?.formId}/answer/${sessionId}`,
				false,
				(payload, status, request) => {
				if (status === 200) {
					resolve(
						request?.data?.meta?.messages?.success?.length
							? request?.data?.meta?.messages
							: { success: t('Katılım güncellendi, teşekkür ederiz.') }
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Katılım güncellenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
};

export default eventServices;
